import { render, staticRenderFns } from "./TabArmature.vue?vue&type=template&id=647ff18e&scoped=true&"
import script from "./TabArmature.vue?vue&type=script&lang=ts&"
export * from "./TabArmature.vue?vue&type=script&lang=ts&"
import style0 from "./TabArmature.vue?vue&type=style&index=0&id=647ff18e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ff18e",
  null
  
)

export default component.exports